import { Flex,Text } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { getDifferenceInDDHHMMSS } from '../../utils/date.utils'

const StatusTimer = (props) => {
const {statusDueDate} = props
const [currentDatetime, setCurrentDateTime] = useState(new Date())
const {timeFlag,days,hours,minutes,seconds} = getDifferenceInDDHHMMSS(statusDueDate,currentDatetime)
 
useEffect(() => {
  const timerInterval = setInterval(() => {
    setCurrentDateTime(new Date())
  }, 1000);

  return () => {
    clearInterval(timerInterval)
  }
}, [])

  return (
    <Flex justifyContent='center' alignItems='center'>
        {days==='00'?
        <Text color={timeFlag === 'negative'?'red':'black'}>{hours}:{minutes}:{seconds}</Text>
        : <Text color={timeFlag === 'negative'?'red':'black'}>{days}:{hours}:{minutes}:{seconds}</Text>
  }
    </Flex>
  )
}

export default StatusTimer